import { render, staticRenderFns } from "./OneImageUnderstanding.vue?vue&type=template&id=414e32f8&scoped=true"
import script from "./OneImageUnderstanding.vue?vue&type=script&setup=true&lang=js"
export * from "./OneImageUnderstanding.vue?vue&type=script&setup=true&lang=js"
import style0 from "./OneImageUnderstanding.vue?vue&type=style&index=0&id=414e32f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414e32f8",
  null
  
)

export default component.exports